import { Icon } from '@/components/icons/Icon'
import { cn } from '@/utils/commonUtil'

import styles from './StatCommonIconChevron.module.scss'

type Props = {
  variant: 'veryLow' | 'low' | 'slightlyLow' | 'neutral' | 'slightlyHigh' | 'high' | 'veryHigh'
}

export const StatCommonIconChevron = ({ variant }: Props) => {
  const icon =
    variant === 'veryHigh' || variant === 'veryLow'
      ? 'chevronTripleUp'
      : variant === 'low' || variant === 'high'
        ? 'chevronDoubleUp'
        : variant === 'slightlyLow' || variant === 'slightlyHigh'
          ? 'chevronSingleUp'
          : undefined

  if (!icon) return null

  return (
    <span className={cn(styles.container, { styles, variant })}>
      <Icon name={icon} />
    </span>
  )
}
